import { TRESPONSE_TNA_TEMPLATE_LISTING, TTnaTemplateDTO } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import { TTableRowNode } from '../../table.type';

export const TNA_TEMPLATES_TABLE_MODEL = {
  createModel: (items: TRESPONSE_TNA_TEMPLATE_LISTING['templates']) => {
    return ModifiersZTableModel.createTableModel(
      items,
      {
        padding: 8,
        select: {
          position: 'START',
          isMulti: false,
          size: 'DEFAULT',
        },
        edit: {
          hasAddRow: false,
          hasDeleteRow: true,
        },
        headerConfig: [
          {
            type: 'TEXT_CELL',
            text: 'ID',
            isHidden: true,
            liftedInput: {
              input: {
                type: 'INPUT',
                subType: 'text',
                setValue: (value: TTnaTemplateDTO) => value.templateId,
              },
              metadata: {
                keyName: 'templateId',
              },
            },
          },
          {
            type: 'TEXT_CELL',
            text: 'TEMPLATE NAME',
            widthInPx: 200,
            liftedInput: {
              input: {
                type: 'INPUT',
                subType: 'text',
                setValue: (value: TTnaTemplateDTO) => value.name,
                placeholder: 'Enter template name',
              },
              metadata: {
                keyName: 'updatedName',
                isRequired: true,
              },
            },
          },
          {
            type: 'TEXT_CELL',
            text: 'STATUS',
            widthInPx: 200,
            align: 'center',
          },
          {
            type: 'TEXT_CELL',
            text: 'DURATION IN DAYS',
            widthInPx: 200,
            align: 'center',
          },
          {
            type: 'ACTION_CELL',
            actionType: 'COPY',
            widthInPx: 200,
            align: 'right',
            asIcon: true,
          },
        ],
      },
      (item): TTableRowNode<TTnaTemplateDTO> => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: [
            {
              type: 'TEXT_CELL',
              text: item.templateId || '',
            },
            {
              type: 'TEXT_CELL',
              text: item.name,
              href: '/tna/tna-details',
              queryParams: { templateName: item.name, templateId: item.templateId },
            },
            {
              type: 'TEXT_CELL',
              text: '',
              align: 'center',
              tag: {
                tagContent: item.status,
                tagBgColor: item.status === 'Complete' ? 'green' : 'yellow',
              },
            },
            {
              type: 'TEXT_CELL',
              text: item.criticalPathDurationInDays ?? '--',
              align: 'center',
            },
            {
              type: 'ACTION_CELL',
              actionType: 'COPY',
              asIcon: true,
              align: 'right',
              showLargeIcon: true,
            },
          ],
        };
      },
    );
  },
};
